import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { Header } from './components/layout/Header';
import { Footer } from './components/layout/Footer';
import ScrollToTop from './components/ScrollToTop';
import CookieConsentBanner from './components/CookieConsentBanner';
import HomePage from './pages/HomePage';
import PackagesPage from './pages/PackagesPage';
import ComparisonPage from './pages/ComparisonPage';
import ContactPage from './pages/ContactPage';
import CDNPage from './pages/CDNPage';
import CloudPage from './pages/CloudPage';
import DeployPage from './pages/DeployPage';
import AdminPage from './pages/AdminPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import TritonDocsPage from './pages/TritonDocsPage';
import DoNotSellPage from './pages/DoNotSellPage';

function App() {
  return (
    <div className="App">
      <Toaster 
        position="top-right" 
        toastOptions={{
          style: {
            background: '#0a0f1a',
            border: '1px solid rgba(42, 95, 246, 0.3)',
            color: '#ffffff',
            borderRadius: '12px'
          }
        }}
      />
      <BrowserRouter>
        <ScrollToTop />
        <CookieConsentBanner />
        <Routes>
          {/* Admin route without header/footer */}
          <Route path="/admin" element={<AdminPage />} />
          
          {/* Docs route with header/footer */}
          <Route path="/docs/*" element={
            <>
              <Header />
              <main>
                <TritonDocsPage />
              </main>
              <Footer />
            </>
          } />
          
          {/* Public routes with header/footer */}
          <Route path="/*" element={
            <>
              <Header />
              <main>
                <Routes>
                  <Route path="/" element={<HomePage />} />
                  <Route path="/packages" element={<PackagesPage />} />
                  <Route path="/comparison" element={<ComparisonPage />} />
                  <Route path="/contact" element={<ContactPage />} />
                  <Route path="/cdn" element={<CDNPage />} />
                  <Route path="/cloud" element={<CloudPage />} />
                  <Route path="/deploy" element={<DeployPage />} />
                  <Route path="/privacy" element={<PrivacyPolicyPage />} />
                  <Route path="/terms" element={<TermsOfServicePage />} />
                  <Route path="/do-not-sell" element={<DoNotSellPage />} />
                </Routes>
              </main>
              <Footer />
            </>
          } />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
